import { Component, OnInit } from '@angular/core';
import { ScreenshotsComponent } from '../screenshots/screenshots.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-screenshots-r11',
	templateUrl: './screenshots-r11.component.html',
	styleUrls: ['./screenshots-r11.component.css']
})
export class ScreenshotsR11Component extends ScreenshotsComponent implements OnInit {
	public screenshotsArray = [];
	constructor(analyticsService: AnalyticsService, analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	processResponseData(responseData: any) {
		this.screenshotsArray = [];
		for (const response of responseData) {
			const obj = {
				imageURL: response.path,
				date: response.date,
				url: response.url,
				completeURL: response.full_url
			};
			this.screenshotsArray.push(obj);
		}
	}
	ngOnInit() {
		super.ngOnInit();
	}
	ngOnDestroy() {
		super.ngOnDestroy();
	}
}
